import classNames from 'classnames';
import { FC, useRef } from 'react';

import styles from './Carousel.styles.m.css';
import { TCarouselProps } from './Carousel.types';
import { CarouselInfinite } from './CarouselInfinite/CarouselInfinite';
import { CarouselScroll } from './CarouselScroll/CarouselScroll';
import { useItemWidth } from './hooks/useItemWidth';

export const Carousel: FC<TCarouselProps> = ({
  className,
  children,
  isInfinite = false,
  isScrollToActiveOnMount,
  activeIndex,
  itemsToShow,
  gap,
  withShadow,
  onActiveIndexChange,
  scrollByClientWidth,
  fixedItemWidth,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const calculatedItemWidth = useItemWidth(containerRef, itemsToShow, gap);
  const itemWidth = fixedItemWidth ?? calculatedItemWidth;

  return (
    <div
      ref={containerRef}
      className={classNames(className, styles.container)}
    >
      {isInfinite ? (
        <CarouselInfinite
          activeIndex={activeIndex}
          itemsToShow={itemsToShow}
          itemWidth={itemWidth}
          gap={gap}
          withShadow={withShadow}
          onChangeActiveIndex={onActiveIndexChange}
        >
          {children}
        </CarouselInfinite>
      ) : (
        <CarouselScroll
          activeIndex={activeIndex}
          itemsToShow={itemsToShow}
          itemWidth={itemWidth}
          gap={gap}
          withShadow={withShadow}
          onChangeActiveIndex={onActiveIndexChange}
          scrollByClientWidth={scrollByClientWidth}
          isScrollToActiveOnMount={!!isScrollToActiveOnMount}
        >
          {children}
        </CarouselScroll>
      )}
    </div>
  );
};
